import React from "react";
import Navibar from "../components/Navibar";
import Footer from "../components/Footer";
import Counter from "../components/Counter";
import Infra from "../components/Infra";

import Certifications from "../components/Certifications";

export default function VSKAbout() {
  return (
    <>
      <Navibar />

      <div class="page-title-area">
        <div class="d-table">
          <div class="d-table-cell">
            <div class="container">
              <h2>About Us</h2>
            </div>
          </div>
        </div>
      </div>

      <section class="about-area ptb-80">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-12">
              <div class="about-image wow fadeInUp">
                <img src="/img/cot.jpg" alt="ie" />
              </div>
            </div>

            <div class="col-lg-6 col-md-12">
              <div class="about-content">
                <div class="section-title">
                  <h2>VSK TEXTILES "A Legacy of Quality"</h2>
                  <div class="bar"></div>
                </div>

                <p className="text-justify">
                  • <b>Establishment:</b> Founded in 2006, starting as a greige
                  fabric manufacturer. <br />• <b>Transformation:</b> Evolved
                  over nearly 20 years into a premier global export partner
                  specializing in high-end bed linens. <br />•{" "}
                  <b>Core Philosophy:</b> The company believes great linen
                  begins with a deep understanding of the fiber itself. <br />•{" "}
                  <b>Value Proposition:</b> They don't just ship products; they
                  build long-term value, systems, and partnerships for global
                  brands. <br />
                </p>

                <p>
                  <b>Our Goal:</b>{" "}
                </p>
                <p>
                  <p>
                    <b>
                      Our goal is to lead the industry with versatile packaging
                      options and a performance-driven mindset, consistently
                      exceeding customer expectations.
                    </b>
                  </p>
                </p>
              </div>
            </div>
          </div>

          <div class="about-inner-area">
            <div class="row">
              <div class="col-lg-4 col-md-6">
                <div class="about-text">
                  <h3>
                    <b>Our Services: "End-to-End Manufacturing Excellence" </b>
                  </h3>
                  <p className="text-justify">
                    • <b>Integrated Production:</b> Offers fully integrated
                    "Fabric to Finished Product" manufacturing. <br />•{" "}
                    <b>Creative In-House Weaving:</b> In-house weaving
                    capabilities allow for greater creativity and optimized
                    sourcing. <br />• <b>Comprehensive Facilities:</b> <br />•{" "}
                    <b>Weaving Unit:</b> Features 16 Sulzer looms and 16 Air Jet
                    looms, capable of producing 500,000 meters per month. <br />
                    • <b>Cut-to-Pack:</b> Includes specialized cutting, sewing,
                    ironing, checking, and packing departments. <br />•{" "}
                    <b>Speed & Flexibility:</b> Provides low Minimum Order
                    Quantity (MOQ) capabilities (ideal for test marketing) and
                    fast sampling aligned with current trends. <br />•{" "}
                    <b>Quality Assurance:</b> Utilizes a robust "4 Point System"
                    that conforms to international quality requirements. <br />
                  </p>
                </div>
              </div>

              <div class="col-lg-4 col-md-6">
                <div class="about-text">
                  <h3>
                    <b>Our Products: "High-End Bed Linens" </b>
                  </h3>
                  <p className="text-justify">
                    • <b>Segments:</b> Fashion Bedding, Hospitality, and Hotel
                    Linens. <br />• <b>Range of Items:</b> Flat sheets, fitted
                    sheets, duvets/covers, pillowcases, mattress protectors
                    (120TC-800TC), throws, blankets, quilts, and comforters.{" "}
                    <br />• <b>Materials & Textures:</b> <br />•{" "}
                    <b>Premium Fibers:</b> Indian, Supima, Egyptian, and Suvin
                    Cotton; Linen; Tencel & Viscose; and Linen Lyocell. <br />•{" "}
                    <b>Versatile Weaves:</b> Percale, Satin, Twill, Dobby,
                    Jacquard, Seer Sucker, and Waffle/Pique. <br />
                    • Specialized Finishes: Aero Finish, Garment Wash, and
                    various dyeing techniques (Yarn, Reactive, VAT). <br />
                  </p>
                </div>
              </div>

              <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
                <div class="about-text">
                  <h3>
                    <b>Our Sustainability:</b> "Loom-to-Living Room"{" "}
                  </h3>
                  <p className="text-justify">
                    • <b>Solar Power:</b> 100% of one plant is powered by solar
                    energy, with a 90 KW installed capacity that reduces $CO_2$
                    by 106.84 tons annually. <br />• <b>The Zero-Waste Goal:</b>{" "}
                    100% of surplus resources are diverted to employee-only
                    organic farms to ensure a zero-waste cycle. <br />•{" "}
                    <b>Responsible Sourcing:</b> Sustainability is embedded in
                    every stage, from using renewable energy to efficient
                    production. <br />• <b>Global Certifications:</b> The
                    company is certified by GOTS (Global Organic Textile
                    Standard), OEKO-TEX Standard 100, Global Recycled Standard
                    (GRS), Organic 100, and the Better Cotton Initiative (BCI).{" "}
                    <br />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Infra />
      <Counter />
      <Certifications />
      <Footer />
    </>
  );
}
